// Anchos compartidos del sidebar fijo (desktop, xl+) — usados por Sidebar,
// SidebarContent/SidebarLinks (para el modo riel de íconos), AdminNavbar
// (para su offset "left") y layouts/Admin.js (para el ancho de MainPanel),
// así los 4 quedan sincronizados sin repetir el número.
export const SIDEBAR_W_EXPANDED = 240;
export const SIDEBAR_W_COLLAPSED = 76;
